import { Breadcrumbs, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { styled } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faUserCheck } from "@fortawesome/pro-duotone-svg-icons";
const StyledLink = styled(Link)({
    color: "var(--text-color)",
    textDecoration: "none",
});
const RequestsBreadcrumb = ({ item }) => {
    return (
        <Breadcrumbs aria-label='breadcrumb'>
            <StyledLink to={"/"}>
                <FontAwesomeIcon icon={faHouse} />
                &nbsp;Home
            </StyledLink>
            <StyledLink to={"/accessrequests"}>
                <FontAwesomeIcon icon={faUserCheck} />
                &nbsp;Requests
            </StyledLink>
            <Typography color='textPrimary'>
                Request {item.id} - {item.firstName} {item.lastName}
            </Typography>
        </Breadcrumbs>
    );
};

export default RequestsBreadcrumb;
